module.exports = __webpack_public_path__ + "img/PL08883.a1e95dc4.png";